<!--
    calendarType
    房源详情页 ： 1;
    续订 ： 2;
    首页 ： 3,
    离开 ： 4,
    商品详情页 ： 5
 -->
<template>
  <div
    v-if="calendarType == 1 || calendarType == 3 || calendarType == 5"
    class="calendar_wrap"
  >
    <div v-if="calendarType == 1 || calendarType == 3">
      <div class="close_icon" v-if="closeBtn">
        <i @click="close" class="icon iconfont">&#xe73d;</i>
      </div>
      <div class="calendar_head">
        <div class="calendar_head_box">
          <p class="calendar_head_title">选择入住离开日期</p>
          <p v-if="hasAbordCity == 1 && nation">
            以<span>{{ nation }}</span
            >时间为准
          </p>
        </div>
      </div>
      <div class="calendar_content clearfix">
        <div
          class="calendar_box clearfix"
          v-for="(values, key, index) in calendar"
          :key="index"
        >
          <div class="year_wrap">
            <div class="year">
              {{ values.cur_year || "--" }} . {{ values.cur_month || "--" }}
            </div>
          </div>
          <div class="week_wrap">
            <div class="week" v-for="(week, key, index) in weeks" :key="index">
              {{ week }}
            </div>
          </div>
          <div class="days">
            <div
              class="grid empty"
              v-for="(value, key, index) in values.emptyGrids"
              :key="index"
            ></div>
            <div
              @click="
                chooseDate(
                  values.fullDate[key],
                  values.cur_month,
                  key + 1,
                  values.cur_year,
                  values.mindex,
                  allday.luBookState,
                  values.allJson,
                  values.size
                )
              "
              :key="index"
              class="grid white-color box box-align-center box-pack-center"
              v-for="(allday, key, index) in values.days"
            >
              <div
                :class="[
                  (currentItem == key + 1 &&
                    currentMonth == values.cur_month) ||
                  (startDateFul <= values.fullDate[key] &&
                    values.fullDate[key] <= endDateFul &&
                    touch)
                    ? 'pink-bg'
                    : '',
                  values.fullDate[key] < today && values.cur_year <= thisYear
                    ? 'grey'
                    : 'normal'
                ]"
              >
                <!-- 预订日历 -->
                <div v-if="calendarType == 1">
                  <span class="tips" v-if="values.fullDate[key] == endDateFul">
                    {{ "共" + keepDays + "晚" }}
                    <i class="tip_icon"></i>
                  </span>
                  <div
                    class="pwrap"
                    :ymd="`${allday.day}`"
                    :price="allday.price"
                  >
                    <i
                      v-if="
                        allday.priceType == 'fixedprice' &&
                          values.fullDate[key] >= today &&
                          allday.luBookState != 'soldout'
                      "
                      class="sale"
                      >特</i
                    >
                    <p>
                      <span
                        v-if="startDateFul == values.fullDate[key]"
                        :class="
                          values.fullDate[key] < today
                            ? 'cbigfont maxheight'
                            : ''
                        "
                        >入住</span
                      >
                      <span
                        v-else-if="values.fullDate[key] == endDateFul"
                        :class="
                          values.fullDate[key] < today
                            ? 'cbigfont maxheight'
                            : ''
                        "
                        >离开</span
                      >
                      <span
                        v-else
                        :class="
                          values.fullDate[key] < today
                            ? 'cbigfont maxheight'
                            : ''
                        "
                        v-text="
                          values.fullDate[key] == today && !hasAbordCity
                            ? '今天'
                            : key + 1
                        "
                      ></span>
                    </p>
                    <p
                      v-if="
                        values.fullDate[key] >= today &&
                          allday.luBookState == 'soldout'
                      "
                    >
                      <span>已租</span>
                    </p>
                    <p
                      v-else-if="
                        values.fullDate[key] >= today &&
                          allday.luBookState == 'cannotbook'
                      "
                    >
                      <span>
                        不可租
                      </span>
                    </p>
                    <p v-else-if="values.fullDate[key] >= today">
                      <span>
                        {{ allday.priceUnity + allday.price }}
                      </span>
                    </p>
                  </div>
                </div>
                <!-- 标准日历 -->
                <div
                  v-else-if="calendarType == 3"
                  class="elsep"
                  :ymd="
                    `${values.cur_year}-${values.cur_month}-${
                      key + 1 < 10 ? '0' + (key + 1) : key + 1
                    }`
                  "
                >
                  <span class="tips" v-if="values.fullDate[key] == endDateFul">
                    {{ "共" + keepDays + "晚" }}
                    <i class="tip_icon"></i>
                  </span>
                  <div>
                    <p
                      class="cbigfont"
                      v-if="startDateFul == values.fullDate[key]"
                    >
                      入住
                    </p>
                    <p
                      class="cbigfont"
                      v-else-if="values.fullDate[key] == endDateFul"
                    >
                      离开
                    </p>
                    <p class="cbigfont" v-else>
                      {{
                        values.fullDate[key] == today && !Number(hasAbordCity)
                          ? "今天"
                          : key + 1
                      }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="confirmFbtn">
        <div class="confirmBtn" @click="confirm">确认</div>
      </div>
    </div>
    <div v-else>
      <div class="calendar_content clearfix">
        <!-- <v-touch v-on:swipeleft="slideCal('r')"  v-on:swiperight="slideCal('l')"> -->
        <div
          class="calendar_box clearfix"
          v-show="boxIndex == key"
          v-for="(values, key, index) in calendar"
          :key="index"
        >
          <div class="year_wrap">
            <div
              :class="[
                boxIndex == 0
                  ? 'directBtn icon iconfont light'
                  : 'directBtn icon iconfont'
              ]"
              @click="slideCal('l')"
            >
              &#xe741;
            </div>
            <div
              class="year"
              :class="{ isOverseaYear: hasAbordCity == 1 && nation }"
            >
              {{ values.cur_year || "--" }}.{{ values.cur_month || "--" }}
            </div>
            <div class="isOversea" v-if="hasAbordCity == 1 && nation">
              以{{ nation }}时间为准
            </div>
            <div
              :class="[
                boxIndex == 5
                  ? 'directBtn icon iconfont light'
                  : 'directBtn icon iconfont'
              ]"
              @click="slideCal('r')"
              class="rotate180"
            >
              &#xe741;
            </div>
          </div>
          <div class="week_wrap">
            <div class="week" v-for="(week, key, index) in weeks" :key="index">
              {{ week }}
            </div>
          </div>
          <div class="days">
            <div
              class="grid empty"
              v-for="(value, key, index) in values.emptyGrids"
              :key="index"
            ></div>
            <div
              @click="
                chooseDate(
                  values.fullDate[key],
                  values.cur_month,
                  key + 1,
                  values.cur_year,
                  values.mindex,
                  allday.luBookState,
                  values.allJson,
                  values.size
                )
              "
              :key="index"
              class="grid white-color box box-align-center box-pack-center"
              v-for="(allday, key, index) in values.days"
            >
              <div
                :class="[
                  (currentItem == key + 1 &&
                    currentMonth == values.cur_month) ||
                  (startDateFul <= values.fullDate[key] &&
                    values.fullDate[key] <= endDateFul &&
                    touch)
                    ? 'pink-bg'
                    : 'white-bg',
                  values.fullDate[key] < today && values.cur_year <= thisYear
                    ? 'grey'
                    : 'normal'
                ]"
              >
                <div class="pwrap" :ymd="`${allday.day}`" :price="allday.price">
                  <i
                    v-if="
                      allday.priceType == 'fixedprice' &&
                        values.fullDate[key] >= today &&
                        allday.luBookState != 'soldout'
                    "
                    class="sale"
                    >特</i
                  >
                  <p>
                    <span
                      v-if="startDateFul == values.fullDate[key]"
                      :class="
                        values.fullDate[key] < today ? 'cbigfont maxheight' : ''
                      "
                      >入住</span
                    >
                    <span
                      v-else-if="values.fullDate[key] == endDateFul"
                      :class="
                        values.fullDate[key] < today ? 'cbigfont maxheight' : ''
                      "
                      >离开</span
                    >
                    <span
                      v-else
                      :class="
                        values.fullDate[key] < today ? 'cbigfont maxheight' : ''
                      "
                      v-text="values.fullDate[key] == today ? '今天' : key + 1"
                    ></span>
                  </p>
                  <p
                    v-if="
                      values.fullDate[key] >= today &&
                        allday.luBookState == 'soldout'
                    "
                  >
                    <span>已租</span>
                  </p>
                  <p
                    v-else-if="
                      values.fullDate[key] >= today &&
                        allday.luBookState == 'cannotbook'
                    "
                  >
                    <span>
                      不可租
                    </span>
                  </p>
                  <p v-else-if="values.fullDate[key] >= today">
                    <span class="day_price">
                      {{ allday.priceUnity + allday.price }}
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- </v-touch>     -->
      </div>
    </div>
  </div>
  <!-- 续订日历 -->
  <div v-else-if="calendarType == 2" class="calendar_wrap">
    <div class="calendar_content calendar_renew clearfix">
      <div class="calendar_head">
        <div class="calendar_head_box">
          <p class="calendar_head_title">选择离开日期</p>
          <p v-if="hasAbordCity && nation != ''">
            以<span>{{ nation }}</span
            >时间为准
          </p>
        </div>
      </div>
      <div
        class="calendar_box clearfix"
        v-for="(values, key, index) in calendar"
        :key="index"
      >
        <div class="year_wrap">
          <div class="year">
            {{ values.cur_year || "--" }} . {{ values.cur_month || "--" }}
          </div>
        </div>
        <div class="week_wrap">
          <div class="week" v-for="(week, key, index) in weeks" :key="index">
            {{ week }}
          </div>
        </div>
        <div class="days" id="needClass2">
          <div
            class="grid empty"
            v-for="(value, key, index) in values.emptyGrids"
            :key="index"
          ></div>
          <div>
            <div
              @click="
                chooseDate(
                  values.fullDate[key],
                  values.cur_month,
                  key + 1,
                  values.cur_year,
                  allday.luBookState,
                  values.allJson,
                  values.size,
                  values.mindex
                )
              "
              class="grid white-color box box-align-center box-pack-center"
              :key="index"
              v-for="(allday, key, index) in values.days"
              v-if="
                values.fullDate[key] >= parentDateFul &&
                  values.fullDate[key] <= renewvarDay
              "
            >
              <div
                :class="[
                  (currentItem == key + 1 &&
                    currentMonth == values.cur_month) ||
                  (renewDateFul <= values.fullDate[key] &&
                    values.fullDate[key] <= endDateFul &&
                    touch)
                    ? 'pink-bg'
                    : '',
                  parentDateFul <= values.fullDate[key] &&
                  values.fullDate[key] < parentEndDateFul &&
                  touch
                    ? 'pink-bg pink-bg2'
                    : '',
                  values.fullDate[key] < today && values.cur_year <= thisYear
                    ? 'grey'
                    : '',
                  (allday.luBookState == 'soldout' ||
                    allday.luBookState == 'cannotbook') &&
                  values.fullDate[key] >= today &&
                  values.fullDate[key] > endDateFul
                    ? 'soldout'
                    : ''
                ]"
              >
                <div
                  v-if="
                    values.fullDate[key] >= renewDateFul ||
                      values.cur_year > thisYear
                  "
                >
                  <div
                    class="pwrap"
                    :ymd="`${allday.day}`"
                    :price="allday.price"
                    v-if="
                      (values.fullDate[key] > renewDateFul ||
                        values.cur_year > thisYear) &&
                        values.fullDate[key] != endDateFul
                    "
                  >
                    <i
                      v-if="
                        allday.priceType == 'fixedprice' &&
                          values.fullDate[key] >= today &&
                          allday.luBookState != 'soldout'
                      "
                      class="sale"
                      >特</i
                    >
                    <p>
                      <span
                        v-if="values.fullDate[key] == renewDateFul"
                        :class="
                          values.fullDate[key] < today
                            ? 'cbigfont maxheight'
                            : ''
                        "
                        >{{ key + 1 }}</span
                      >
                      <span
                        v-else-if="values.fullDate[key] < renewDateFul"
                        :class="
                          values.fullDate[key] < today
                            ? 'cbigfont maxheight'
                            : ''
                        "
                        v-text="
                          values.fullDate[key] == today && !hasAbordCity
                            ? '今'
                            : key + 1
                        "
                      ></span>
                      <span
                        v-else
                        :class="
                          values.fullDate[key] < today
                            ? 'cbigfont maxheight'
                            : ''
                        "
                        v-text="
                          values.fullDate[key] == today && !hasAbordCity
                            ? '今'
                            : key + 1
                        "
                      ></span>
                    </p>
                    <p
                      v-if="
                        values.fullDate[key] >= today &&
                          allday.luBookState == 'soldout'
                      "
                    >
                      <span>已租</span>
                    </p>
                    <p
                      v-else-if="
                        values.fullDate[key] >= today &&
                          allday.luBookState == 'cannotbook'
                      "
                    >
                      <span>
                        不可租
                      </span>
                    </p>
                    <p v-else-if="values.fullDate[key] >= today">
                      <span>
                        {{ allday.priceUnity + allday.price }}
                      </span>
                    </p>
                  </div>
                  <div
                    class="pwrap"
                    :ymd="`${allday.day}`"
                    :price="allday.price"
                    v-else-if="values.fullDate[key] == renewDateFul"
                  >
                    <i
                      v-if="
                        allday.priceType == 'fixedprice' &&
                          values.fullDate[key] >= today &&
                          allday.luBookState != 'soldout'
                      "
                      class="sale"
                      >特</i
                    >
                    <p>
                      <span
                        v-if="values.fullDate[key] == renewDateFul"
                        :class="
                          values.fullDate[key] < today
                            ? 'cbigfont maxheight'
                            : ''
                        "
                        >续</span
                      >
                      <span
                        v-else-if="values.fullDate[key] < renewDateFul"
                        :class="
                          values.fullDate[key] < today
                            ? 'cbigfont maxheight'
                            : ''
                        "
                        v-text="
                          values.fullDate[key] == today && !hasAbordCity
                            ? '今'
                            : key + 1
                        "
                      ></span>
                      <span
                        v-else
                        :class="
                          values.fullDate[key] < today
                            ? 'cbigfont maxheight'
                            : ''
                        "
                        v-text="
                          values.fullDate[key] == today && !hasAbordCity
                            ? '今'
                            : key + 1
                        "
                      ></span>
                    </p>
                    <p
                      v-if="
                        values.fullDate[key] >= today &&
                          allday.luBookState == 'soldout'
                      "
                    >
                      <span>已租</span>
                    </p>
                    <p
                      v-else-if="
                        values.fullDate[key] >= today &&
                          allday.luBookState == 'cannotbook'
                      "
                    >
                      <span>
                        不可租
                      </span>
                    </p>
                    <p v-else-if="values.fullDate[key] >= today">
                      <span>
                        {{ allday.priceUnity + allday.price }}
                      </span>
                    </p>
                  </div>
                  <div
                    class="pwrap"
                    :ymd="`${allday.day}`"
                    :price="allday.price"
                    v-else-if="values.fullDate[key] == endDateFul"
                  >
                    <i
                      v-if="
                        allday.priceType == 'fixedprice' &&
                          values.fullDate[key] >= today &&
                          allday.luBookState != 'soldout'
                      "
                      class="sale"
                      >特</i
                    >
                    <p>
                      <span
                        v-if="values.fullDate[key] == renewDateFul"
                        :class="
                          values.fullDate[key] < today
                            ? 'cbigfont maxheight'
                            : ''
                        "
                        >{{ key + 1 }}</span
                      >
                      <span
                        v-else-if="values.fullDate[key] < renewDateFul"
                        :class="
                          values.fullDate[key] < today
                            ? 'cbigfont maxheight'
                            : ''
                        "
                        v-text="
                          values.fullDate[key] == today && !hasAbordCity
                            ? '今'
                            : key + 1
                        "
                      ></span>
                      <span
                        v-else-if="values.fullDate[key] == endDateFul"
                        :class="
                          values.fullDate[key] < today
                            ? 'cbigfont maxheight'
                            : ''
                        "
                        >离开</span
                      >
                      <span
                        v-else
                        :class="
                          values.fullDate[key] < today
                            ? 'cbigfont maxheight'
                            : ''
                        "
                        v-text="
                          values.fullDate[key] == today && !hasAbordCity
                            ? '今'
                            : key + 1
                        "
                      ></span>
                    </p>
                    <p
                      v-if="
                        values.fullDate[key] >= today &&
                          allday.luBookState == 'soldout'
                      "
                    >
                      <span>已租</span>
                    </p>
                    <p
                      v-else-if="
                        values.fullDate[key] >= today &&
                          allday.luBookState == 'cannotbook'
                      "
                    >
                      <span>
                        不可租
                      </span>
                    </p>
                    <p v-else-if="values.fullDate[key] >= today">
                      <span>
                        {{ allday.priceUnity + allday.price }}
                      </span>
                    </p>
                  </div>
                </div>
                <div v-else class="elsep">
                  <p class="cbigfont">{{ key + 1 }}</p>
                </div>
              </div>
            </div>
            <div
              v-else
              class="grid white-color box box-align-center box-pack-center"
            >
              <div class="grey">
                <div class="elsep">
                  <p class="cbigfont">
                    <span
                      v-if="values.fullDate[key] == renewDateFul"
                      :class="
                        values.fullDate[key] < today ? 'cbigfont maxheight' : ''
                      "
                      >{{ key + 1 }}</span
                    >
                    <span
                      v-else-if="values.fullDate[key] < renewDateFul"
                      :class="
                        values.fullDate[key] < today ? 'cbigfont maxheight' : ''
                      "
                      v-text="
                        values.fullDate[key] == today && !hasAbordCity
                          ? '今'
                          : key + 1
                      "
                    ></span>
                    <span
                      v-else
                      :class="
                        values.fullDate[key] < today ? 'cbigfont maxheight' : ''
                      "
                      v-text="
                        values.fullDate[key] == today && !hasAbordCity
                          ? '今'
                          : key + 1
                      "
                    ></span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="confirmFbtn">
        <div class="confirmBtn" @click="renewConfirm">确认</div>
      </div>
    </div>
  </div>
  <!-- 退订日历 -->
  <div v-else-if="calendarType == 4" class="calendar_wrap earlyLeavecalendar">
    <div class="unbook_page clearfix">
      <div class="unbook_left_wrap">
        <span>选择离开日期</span>
        <span class="date" v-if="leftResultDate">{{ leftResultDate }}</span>
      </div>
      <div class="calendar_content clearfix">
        <div
          class="calendar_box calendar_box2 clearfix"
          v-for="(values, key, index) in calendar"
          :key="index"
          v-show="showIndex == key"
        >
          <div class="year_wrap">
            <div class="year">
              {{ values.cur_year || "--" }} . {{ values.cur_month || "--" }}
            </div>
          </div>
          <div class="tab_wrap">
            <span
              @click="slideL(values.cur_year, values.cur_month)"
              class="left"
              :class="{ blackBg: showBlackL }"
            ></span>
            <span
              @click="slideR(values.cur_year, values.cur_month)"
              class="right"
              :class="{ blackBg: showBlackR }"
            ></span>
          </div>
          <div class="week_wrap">
            <div class="week" v-for="(week, key, index) in weeks" :key="index">
              {{ week }}
            </div>
          </div>
          <div class="days">
            <div
              class="grid empty"
              v-for="(value, key, index) in values.emptyGrids"
              :key="index"
            ></div>
            <div>
              <div
                @click="
                  chooseDate(
                    values.fullDate[key],
                    values.cur_month,
                    key + 1,
                    values.cur_year,
                    allday.luBookState,
                    values.allJson,
                    values.size,
                    values.mindex
                  )
                "
                class="grid white-color box box-align-center box-pack-center"
                v-for="(allday, key, index) in values.allJson"
                :key="index"
              >
                <div
                  :class="[
                    (currentItem == key + 1 &&
                      currentMonth == values.cur_month) ||
                    (startDateFul < values.fullDate[key] &&
                      values.fullDate[key] < endDateFul &&
                      touch)
                      ? 'pink-bg'
                      : '',
                    values.fullDate[key] == checkInDate.fullDate
                      ? 'pink-bg'
                      : '',
                    values.fullDate[key] < checkInDate.fullDate
                      ? startDateFul
                      : '',
                    values.fullDate[key] >= checkInDate.fullDate &&
                    values.fullDate[key] <= today
                      ? 'grey-bg'
                      : '',
                    values.fullDate[key] >= checkOutDate.fullDate ? 'grey' : ''
                  ]"
                >
                  <div class="elsep">
                    <p class="cbigfont">
                      {{ values.fullDate[key] == today ? "今天" : key + 1 }}
                    </p>
                    <div
                      class="tips"
                      v-if="values.fullDate[key] == checkInDate.fullDate"
                    >
                      入住日期
                    </div>
                    <div
                      class="left_tips"
                      :class="{ downTips: addDownTips }"
                      @click.stop="clearData"
                      v-if="addLeftTips && values.fullDate[key] == endDateFul"
                    >
                      离开日期<i class="xz-icon">&#xe634;</i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Toast } from "mint-ui";
import { bookCalendar } from "../service/getData";
// import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
  data() {
    return {
      startDay: "",
      endDay: "",
      curDay: "",
      curYear: "",
      curMonth: "",
      cur_year: "",
      cur_month: "",
      newYear: "",
      newMonth: "",
      days: "",
      empytGrids: "",
      calendar: {},
      choosed: false,
      currentItem: "",
      hasEmptyGrid: "",
      hasAbordCity: this.getStore("hasAbordCity")
        ? this.getStore("hasAbordCity")
        : "",
      nation: this.getStore("cityName") ? this.getStore("cityName") : false,
      currentMonth: "",
      weeks: ["日", "一", "二", "三", "四", "五", "六"],
      startDate: {},
      endDate: {},
      oneDate: {},
      twoDate: {},
      startDateFul: "",
      endDateFul: "",
      touch: true,
      today: "",
      search: "0",
      thisYear: new Date().getFullYear(),
      keepDays: "",
      monthLength: [],
      allDayList: [],
      // calendarType: this.$route.query.calendarType ? this.$route.query.calendarType : 3,
      setData: this.getStore("setData") ? this.getStore("setData") : "",
      luId: "",
      allJson: [],
      jsonDate: [],
      showIndex: 0,
      renewvarDay: "",
      parentDateFul: "",
      parentEndDateFul: "",
      renewYear: "",
      addLeftTips: false,
      addDownTips: false,
      leftResultDate: "",
      lastcurYear: "",
      checkInYear: "",
      checkOutYear: "",
      nextUrl: "",
      inDate: "",
      showBlackL: false,
      showBlackR: false,
      checkInDate: {},
      checkOutDate: {},
      closeBtn: true,
      fomatSetData: "",
      boxIndex: 0,
      totalPrice: 0,
      laststartDate: "",
      lastendDate: ""
      // swiperOption: {
      //     notNextTick: true,
      //     grabCursor : true,
      //     setWrapperSize :true,
      //     paginationClickable :true,
      //     prevButton:'.swiper-button-prev',
      //     nextButton:'.swiper-button-next',
      //     // scrollbar:'.swiper-scrollbar',
      //     mousewheelControl : true,
      //     observeParents:true,
      // }
    };
  },
  // components: {
  //     swiper,
  //     swiperSlide
  // },
  props: {
    calendarType: {
      type: Number
    },
    isComponent: {
      type: Boolean,
      default: false
    },
    propLuId: {
      type: String
    },
    miniday: {
      type: String
    },
    maxyday: {
      type: String
    }
  },
  created() {
    this.upLuId();
  },
  mounted() {
    this.init();
  },
  // computed: {
  //     swiper() {
  //         return this.$refs.mySwiper.swiper
  //     }
  // },
  methods: {
    init() {
      const _this = this;
      const date = new Date();
      const calendarList = [];
      _this.cur_year = date.getFullYear();
      if (_this.getStore("setData")) {
        _this.fomatSetData = JSON.parse(_this.getStore("setData"));
        _this.startDateFul = _this.fomatSetData.startDateFul;
        _this.endDateFul = _this.fomatSetData.endDateFul;
        _this.keepDays = _this.fomatSetData.keepDays;
      }
      if (!this.$route.query.calendarType) {
        _this.closeBtn = false;
      }
      _this.cur_month = date.getMonth();
      this.getMonthIndex();
      _this.handleCalendar();
      if (_this.today > _this.startDateFul) {
        _this.removeStore("setData");
      }
    },
    getMonthIndex() {
      const date = new Date();
      const currentMonth = date.getMonth() + 1;
      if (this.startDateFul) {
        const chooseMonth = this.startDateFul.slice(4, 6);
        let monthIndex = chooseMonth - currentMonth;
        monthIndex < 0 ? (monthIndex = 12 + monthIndex) : monthIndex;
        this.boxIndex = monthIndex;
      }
    },
    initCalendar() {
      if (this.getStore("setData")) {
        this.fomatSetData = JSON.parse(this.getStore("setData"));
        this.startDateFul = this.fomatSetData.startDateFul;
        this.endDateFul = this.fomatSetData.endDateFul;
        this.keepDays = this.fomatSetData.keepDays;
      }
    },
    upLuId() {
      if (this.propLuId) {
        this.luId = this.propLuId;
      } else {
        this.luId = this.$route.query.luId ? this.$route.query.luId : "";
      }
    },
    getCalendar(luId, startDate, endDate) {
      const _this = this;
      _this
        .$get(bookCalendar, {
          luId: this.luId,
          startDate: startDate,
          endDate: endDate
        })
        .then(response => {
          if (response.status == 200) {
            _this.jsonDate = response.content;
            _this.setStore("jsonDate", response.content);
            _this.calendarCalculate(_this.today, response.content);
          }
        });
    },
    getThisMonthDays(year, month) {
      return new Date(year, month, 0).getDate();
    },
    getFirstDayOfWeek(year, month) {
      return new Date(Date.UTC(year, month - 1, 1)).getDay();
    },
    calculateEmptyGrids(year, month) {
      const _this = this;
      const firstDayOfWeek = _this.getFirstDayOfWeek(year, month);
      const emptyGrids = [];
      if (firstDayOfWeek > 0) {
        for (let i = 0; i < firstDayOfWeek; i++) {
          emptyGrids.push(i);
        }
        _this.hasEmptyGrid = true;
        _this.emptyGrids = emptyGrids;
      } else {
        _this.hasEmptyGrid = false;
        _this.emptyGrids = [];
      }
    },
    calculateDays(year, month) {
      const _this = this;
      const days = [];
      const thisMonthDays = _this.getThisMonthDays(year, month);
      for (let i = 1; i <= thisMonthDays; i++) {
        days.push(i);
      }
      _this.days = days;
    },
    handleCalendar() {
      const _this = this;
      const date = new Date();
      _this.curYear = date.getFullYear();
      _this.curMonth = _this.fix(date.getMonth() + 1, 2);
      _this.curDay = _this.fix(date.getDate(), 2);
      var getMonth = _this.fix(date.getMonth() + 6, 2);
      const today = _this.curYear + _this.curMonth + _this.curDay;
      _this.today = _this.curYear + _this.curMonth + _this.curDay;
      _this.laststartDate =
        _this.curYear + "-" + _this.curMonth + "-" + _this.curDay;
      _this.lastendDate = _this.curYear + "-12-31";
      var getMonth = _this.fix(date.getMonth() + 6, 2);
      let lastcurYear = _this.curYear;
      if (getMonth > 12) {
        getMonth = _this.fix(getMonth - 12, 2);
        lastcurYear = _this.curYear + 1;
      }
      const lastDay = _this.getDaysInOneMonth(lastcurYear, getMonth);
      _this.laststartDate = _this.curYear + "-" + _this.curMonth + "-01";
      _this.lastendDate = lastcurYear + "-" + getMonth + "-" + lastDay;
      if (
        _this.calendarType == 1 ||
        _this.calendarType == 2 ||
        _this.calendarType == 5
      ) {
        /* 预定页,退续页,房源详情页日历 */

        _this.getCalendar(_this.luId, _this.laststartDate, _this.lastendDate);
      } else if (_this.calendarType == 4) {
        /* 提前离开日历 */
        _this.checkOutYear = _this.fomatSetData.checkOutDay.slice(0, 4);
        _this.checkInYear = _this.fomatSetData.checkInDay.slice(0, 4);
        _this.checkInDate.fullDate = _this.fomatSetData.startDateFul;
        _this.checkOutDate.fullDate = _this.fomatSetData.endDateFul;
        if (
          _this.checkOutDate.fullDate.slice(0, 6) >=
          _this.checkInDate.fullDate.slice(0, 6)
        ) {
          _this.showBlackR = true;
        }
        _this.getCalendar(_this.luId, _this.laststartDate, _this.lastendDate);
      } else {
        /* 首页日历 */
        _this.calendarCalculate(today, "");
      }
    },
    calendarCalculate(today, jsonCal) {
      const _this = this;
      const calendarList = [];
      let allDayList = [];
      const jsonCalendar = jsonCal;
      if (_this.calendarType == 2) {
        _this.renewDateFul = JSON.parse(_this.getStore("orderInfo"))
          .checkInDate.split(".")
          .join("");
        _this.parentDateFul = _this.fomatSetData.startDateFul;
        _this.parentEndDateFul = _this.fomatSetData.endDateFul;
        for (var i = 0; i < _this.jsonDate.length; i++) {
          if (
            (_this.jsonDate[i].luBookState == "soldout" ||
              _this.jsonDate[i].luBookState == "cannotbook") &&
            _this.jsonDate[i].day.split("-").join("") > _this.renewDateFul
          ) {
            _this.renewvarDay = _this.jsonDate[i].day.split("-").join("");
            _this.renewYear = _this.jsonDate[i].day.slice(0, 4);
            break;
          }
        }
        if (_this.renewvarDay == "") {
          _this.renewYear = _this.jsonDate[_this.jsonDate.length - 1].day.slice(
            0,
            4
          );
          _this.renewvarDay = _this.jsonDate[_this.jsonDate.length - 1].day
            .split("-")
            .join("");
        }
      } else if (_this.calendarType == 1) {
        for (var i = 0; i < _this.jsonDate.length; i++) {
          if (
            _this.jsonDate[i].luBookState != "canbook" &&
            _this.jsonDate[i].day.split("-").join("") >= _this.startDateFul &&
            _this.jsonDate[i].luBookState != "canbook" &&
            _this.jsonDate[i].day.split("-").join("") < _this.endDateFul
          ) {
            Toast("包含不可租时段");
            _this.clearData();
            break;
          }
        }
      }
      for (var i = 0; i <= 5; i++) {
        let newMonth = _this.cur_month + 1;
        let newYear = _this.cur_year;
        if (newMonth > 12) {
          newYear = _this.cur_year + 1;
          newMonth = 1;
        }
        _this.calculateDays(newYear, newMonth);
        _this.calculateEmptyGrids(newYear, newMonth);
        _this.cur_year = newYear;
        _this.cur_month = newMonth;
        const fullDays = [];
        let fullMonth = [];
        const fullDate = [];
        fullMonth = _this.fix(_this.cur_month, 2);
        _this.monthLength.push(_this.days.length);
        for (let j = 0; j < _this.days.length; j++) {
          fullDate.push(newYear + fullMonth + _this.fix(_this.days[j], 2));
        }
        if (_this.calendarType != 3) {
          _this.days = _this.allJson = jsonCalendar.splice(
            0,
            _this.days.length
          );
        }
        const dateList = {
          mindex: i,
          days: _this.days,
          emptyGrids: _this.emptyGrids,
          hasEmptyGrid: _this.hasEmptyGrid,
          cur_year: _this.cur_year,
          cur_month: fullMonth,
          week: _this.week,
          fullDate: fullDate,
          allJson: _this.allJson,
          size: _this.days.length
        };
        allDayList += dateList.days;
        calendarList.push(dateList);
      }
      _this.jsonDate = JSON.parse(_this.getStore("jsonDate"));
      _this.calendar = calendarList;
      _this.today = today;
      _this.allDayList = allDayList;
    },
    chooseDate(e, month, index, year, mindex, lutype, allDays, size) {
      var _this = this;
      if (_this.calendarType == 1 || _this.calendarType == 5) {
        /* 预定页日历 */
        if (
          (e >= _this.today && lutype != "soldout" && lutype != "cannotbook") ||
          (JSON.stringify(_this.oneDate) != "{}" && e >= _this.today)
        ) {
          var spliteMonth = allDays;
          if (
            _this.startDateFul &&
            _this.endDateFul &&
            lutype != "soldout" &&
            lutype != "cannotbook"
          ) {
            _this.clearData();
          } else if (
            (_this.startDateFul && _this.endDateFul && lutype == "soldout") ||
            (_this.startDateFul && _this.endDateFul && lutype == "cannotbook")
          ) {
            return;
          }
          _this.currentItem = index;
          _this.currentMonth = month;
          _this.touch = true;
          var dateFormatMonth = _this.fix(_this.currentMonth, 2);
          var dateFormatDay = _this.fix(_this.currentItem, 2);
          if (
            _this.oneDate.countDate < year + dateFormatMonth + dateFormatDay &&
            _this.oneDate.lutype != "soldout"
          ) {
            var dateFormatMonth = _this.fix(_this.currentMonth, 2);
            var dateFormatDay = _this.fix(_this.currentItem, 2);
            _this.twoDate = {
              countDate: year + dateFormatMonth + dateFormatDay,
              month: _this.currentMonth,
              day: _this.currentItem,
              endYear: year,
              calDays: allDays,
              index: index,
              size: size,
              mindex: mindex
            };
            if (_this.oneDate.countDate < _this.twoDate.countDate) {
              _this.startYear = _this.oneDate.year;
              _this.endYear = _this.twoDate.year;
              _this.startDate =
                _this.oneDate.month + "月" + _this.oneDate.day + "日";
              _this.endDate =
                _this.twoDate.month + "月" + _this.twoDate.day + "日";
              _this.startDateFul = _this.oneDate.countDate;
              _this.endDateFul = _this.twoDate.countDate;
              var setOneDay = _this.fix(_this.oneDate.day, 2);
              var setTwoDay = _this.fix(_this.twoDate.day, 2);
              var finData = [];
              var keepDays = 0;
              if (_this.oneDate.mindex != _this.twoDate.mindex) {
                var start = 0;
                var end = 0;
                for (var i = 0; i < _this.oneDate.mindex; i++) {
                  start += Number(_this.monthLength[i]);
                }
                for (let j = 0; j < _this.twoDate.mindex; j++) {
                  end += Number(_this.monthLength[j]);
                }
                start += _this.oneDate.index - 1;
                end += _this.twoDate.index;
                finData = _this.jsonDate.slice(start, end);
                keepDays = end - start - 1;
              } else {
                const allData = _this.oneDate.calDays;
                const allindex = _this.oneDate.index;
                finData = allData.slice(
                  _this.oneDate.index - 1,
                  _this.twoDate.index
                );
                keepDays = finData.length - 1;
              }
              var tPrice = 0;
              for (var i = 0; i < finData.length - 1; i++) {
                if (
                  finData[i].luBookState == "soldout" ||
                  finData[i].luBookState == "cannotbook"
                ) {
                  Toast({
                    message: "包含不可租时段",
                    duration: 2000
                  });
                  _this.clearData();
                  return;
                } else {
                  var minDays = JSON.parse(_this.getStore("setData"))
                    ? Number(JSON.parse(_this.getStore("setData")).minDays)
                    : "";
                  var maxDays = JSON.parse(_this.getStore("setData"))
                    ? Number(JSON.parse(_this.getStore("setData")).maxDays)
                    : "";
                  if (keepDays < minDays) {
                    Toast({
                      message: "预订需大于" + minDays + "天",
                      duration: 2000
                    });
                    _this.endDateFul = "";
                    _this.twoDate = {};
                    _this.currentItem = _this.oneDate.index;
                    _this.currentMonth = _this.oneDate.month;
                    return;
                  } else if (maxDays && maxDays !== "无限") {
                    if (keepDays > maxDays) {
                      Toast({
                        message: "预订不得超过" + maxDays + "天",
                        duration: 2000
                      });
                      _this.endDateFul = "";
                      _this.twoDate = {};
                      _this.currentItem = _this.oneDate.index;
                      _this.currentMonth = _this.oneDate.month;
                      return;
                    }
                  } else {
                    tPrice += Number(finData[i].price);
                  }
                }
              }
              _this.keepDays = keepDays;
              // 去除最后一天的价格
              _this.totalPrice = tPrice;
              var setData = {
                startDate: _this.startDate,
                endDate: _this.endDate,
                startDateFul: _this.startDateFul,
                endDateFul: _this.endDateFul,
                checkInDay:
                  _this.oneDate.startYear +
                  "-" +
                  _this.fix(_this.oneDate.month, 2) +
                  "-" +
                  _this.fix(setOneDay, 2),
                checkOutDay:
                  _this.twoDate.endYear +
                  "-" +
                  _this.fix(_this.twoDate.month, 2) +
                  "-" +
                  _this.fix(setTwoDay, 2),
                price: _this.totalPrice,
                maxDays: _this.maxyday,
                minDays: _this.miniday,
                keepDays: keepDays
              };
              setData = JSON.stringify(setData);
              _this.setStore("setData", setData);
              // 详情页选取日历日期后实时按钮显示对应总价格
              _this.$store.commit("setData", setData);
            }
          } else if (
            _this.oneDate.countDate ==
            year + dateFormatMonth + dateFormatDay
          ) {
            _this.clearData();
            // 当取消详情页的选中状态时通知按钮隐藏价格
            var setData = {
              price: undefined,
              keepDays: undefined
            };
            setData = JSON.stringify(setData);
            _this.$store.commit("setData", setData);
          } else {
            var dateFormatMonth = _this.fix(_this.currentMonth, 2);
            var dateFormatDay = _this.fix(_this.currentItem, 2);
            _this.oneDate = {
              countDate: year + dateFormatMonth + dateFormatDay,
              month: _this.currentMonth,
              day: _this.currentItem,
              startYear: year,
              calDays: allDays,
              index: index,
              size: size,
              mindex: mindex,
              lutype: lutype
            };
            _this.startDateFul = _this.oneDate.countDate;
            _this.setStore("lasetFirst", index);

            // 当取消详情页的选中状态时通知按钮隐藏价格
            var setData = {
              price: undefined,
              keepDays: undefined
            };
            setData = JSON.stringify(setData);
            _this.$store.commit("setData", setData);
          }
        }
      } else if (_this.calendarType == 2) {
        /* 续订页日历 */
        if (e >= _this.today) {
          if (e == _this.renewDateFul) {
            return;
          }
          var spliteMonth = allDays;
          const jsonDate = _this.jsonDate;
          _this.currentItem = index;
          _this.currentMonth = month;
          _this.touch = true;
          var dateFormatMonth = _this.fix(_this.currentMonth, 2);
          var dateFormatDay = _this.fix(_this.currentItem, 2);
          _this.twoDate = {
            countDate: year + dateFormatMonth + dateFormatDay,
            month: _this.currentMonth,
            day: _this.currentItem,
            startYear: year,
            calDays: allDays,
            index: index,
            size: size,
            mindex: mindex
          };
          if (_this.twoDate.countDate == _this.endDateFul) {
            _this.twoDate = {};
            _this.endDateFul = _this.renewDateFul;
            _this.currentItem = _this.renewDateFul.slice(6);
            _this.startDateFul = _this.fomatSetData.startDateFul;
            _this.currentMonth = _this.renewDateFul.slice(4, 6);
            return;
          } else {
            _this.endDateFul = _this.twoDate.countDate;
          }
          var setTwoDay = _this.fix(_this.twoDate.day, 2);
          var finData = [];
          var keepDays = 0;
          var start = _this.renewDateFul;
          start =
            start.slice(0, 4) + "." + start.slice(4, 6) + "." + start.slice(6);
          var end = _this.twoDate.countDate;
          end = end.slice(0, 4) + "." + end.slice(4, 6) + "." + end.slice(6);
          const days = _this.coumpent(start, end);
          var minDays = _this.fomatSetData.minDays;
          var maxDays = _this.fomatSetData.maxDays;
          if (days < minDays) {
            Toast({
              message: "预订需大于" + minDays + "天",
              duration: 2000
            });
            _this.endDateFul = _this.renewDateFul;
            _this.currentItem = _this.renewDateFul.slice(6);
            _this.startDateFul = _this.fomatSetData.startDateFul;
            _this.currentMonth = _this.renewDateFul.slice(4, 6);
            _this.twoDate = {};
            return;
          } else if (maxDays && days > maxDays) {
            Toast({
              message: "预订不得超过" + maxDays + "天",
              duration: 2000
            });
            _this.endDateFul = _this.renewDateFul;
            _this.currentItem = _this.renewDateFul.slice(6);
            _this.currentMonth = _this.renewDateFul.slice(4, 6);
            _this.twoDate = {};
            return;
          }
          var tPrice = 0;
          _this.endDateFul = _this.twoDate.countDate;
          var setData = {
            startDate: _this.startDate,
            endDate: _this.endDate,
            startDateFul: _this.startDateFul,
            endDateFul: _this.endDateFul,
            checkInDay: start.split(".").join("-"),
            checkOutDay:
              _this.twoDate.endYear +
              "-" +
              _this.fix(_this.twoDate.month, 2) +
              "-" +
              _this.fix(setTwoDay, 2),
            price: _this.totalPrice
          };
          setData = JSON.stringify(setData);
          _this.setStore("setData", setData);
        }
      } else if (_this.calendarType == 3) {
        /* 首页日历 */
        if (e >= _this.today) {
          if (_this.startDateFul && _this.endDateFul) {
            _this.clearData();
          }
          _this.currentItem = index;
          _this.currentMonth = month;
          _this.touch = true;
          var dateFormatMonth = _this.fix(_this.currentMonth, 2);
          var dateFormatDay = _this.fix(_this.currentItem, 2);
          if (
            _this.oneDate.countDate <
            year + dateFormatMonth + dateFormatDay
          ) {
            var dateFormatMonth = _this.fix(_this.currentMonth, 2);
            var dateFormatDay = _this.fix(_this.currentItem, 2);
            _this.twoDate = {
              countDate: year + dateFormatMonth + dateFormatDay,
              month: _this.currentMonth,
              day: _this.currentItem,
              endYear: year,
              mindex: mindex,
              index: index,
              calDays: allDays,
              size: size
            };
            if (_this.oneDate.countDate < _this.twoDate.countDate) {
              _this.startYear = _this.oneDate.year;
              _this.endYear = _this.twoDate.year;
              _this.startDate =
                _this.oneDate.month + "月" + _this.oneDate.day + "日";
              _this.endDate =
                _this.twoDate.month + "月" + _this.twoDate.day + "日";
              _this.startDateFul = _this.oneDate.countDate;
              _this.endDateFul = _this.twoDate.countDate;
              var setOneDay = _this.fix(_this.oneDate.day, 2);
              var setTwoDay = _this.fix(_this.twoDate.day, 2);
              _this.keepDays = _this.coumpent(
                this.oneDate.startYear +
                  "." +
                  _this.oneDate.month +
                  "." +
                  setOneDay,
                _this.twoDate.endYear +
                  "." +
                  _this.twoDate.month +
                  "." +
                  setTwoDay
              );
              let showToday = false;
              if (_this.keepDays == 1 && _this.today == _this.startDateFul) {
                showToday = true;
              }
              var setData = {
                startDate: _this.startDate,
                endDate: _this.endDate,
                startDateFul: _this.startDateFul,
                endDateFul: _this.endDateFul,
                checkInDay:
                  _this.oneDate.startYear +
                  "-" +
                  _this.oneDate.month +
                  "-" +
                  setOneDay,
                checkOutDay:
                  _this.twoDate.endYear +
                  "-" +
                  _this.twoDate.month +
                  "-" +
                  setTwoDay,
                checkIn: _this.oneDate.month + "." + setOneDay,
                checkOut: _this.twoDate.month + "." + setTwoDay,
                keepDays: _this.keepDays,
                showToday: showToday
              };
              _this.setData = JSON.stringify(setData);
            }
          } else if (
            _this.oneDate.countDate ==
            year + dateFormatMonth + dateFormatDay
          ) {
            _this.clearData();
          } else {
            var dateFormatMonth = _this.fix(_this.currentMonth, 2);
            var dateFormatDay = _this.fix(_this.currentItem, 2);
            _this.oneDate = {
              countDate: year + dateFormatMonth + dateFormatDay,
              month: _this.currentMonth,
              day: _this.currentItem,
              startYear: year,
              mindex: mindex,
              index: index,
              calDays: allDays,
              size: size
            };
            _this.startDateFul = _this.oneDate.countDate;
            _this.setStore("lasetFirst", index);
          }
        }
      } else if (_this.calendarType == 4) {
        var _this = this;
        if (
          e > _this.checkInDate.fullDate &&
          e < _this.checkOutDate.fullDate &&
          e > _this.today
        ) {
          var spliteMonth = allDays;
          if (_this.startDateFul && _this.endDateFul) {
            _this.clearData();
          }
          _this.currentItem = index;
          _this.currentMonth = month;
          _this.touch = true;
          var dateFormatMonth = _this.fix(_this.currentMonth, 2);
          var dateFormatDay = _this.fix(_this.currentItem, 2);
          _this.oneDate = {
            countDate: year + dateFormatMonth + dateFormatDay,
            month: _this.currentMonth,
            day: _this.currentItem,
            startYear: year,
            calDays: allDays,
            index: index,
            size: size,
            mindex: mindex
          };
          _this.startDateFul = _this.checkInDate.fullDate;
          _this.endDateFul = _this.oneDate.countDate;
          _this.addLeftTips = true;
          const nowSdate = _this.fomatSetData.checkInDate;
          const nowMonth =
            _this.oneDate.month >= 10
              ? _this.oneDate.month
              : "0" + _this.oneDate.month;
          const nowDay =
            _this.oneDate.day >= 10
              ? _this.oneDate.day
              : "0" + _this.oneDate.day;
          _this.leftResultDate =
            _this.oneDate.startYear + "." + nowMonth + "." + nowDay;
          if (nowSdate) {
            // 入住日期的后一天；
            const tomDay = _this.getDateFromCurrentDate(nowSdate, 1);
            const leaveDay = _this.leftResultDate.split(".").join("-");
            // 离开的那天不为周日；
            const weekD = _this.getWeekByDay(leaveDay);
            if (tomDay == leaveDay && weekD != "星期日") {
              _this.addDownTips = true;
            } else {
              _this.addDownTips = false;
            }
          }
        }
      }
    },
    // daysCalculate(){
    //     var _this = this;
    //     if(_this.oneDate.mindex != _this.twoDate.mindex){
    //         var start = 0;
    //         var end = 0;
    //         for(var i = 0 ; i < _this.oneDate.mindex ; i ++){
    //             start += Number(_this.monthLength[i]);
    //         }
    //         for(var j = 0 ; j < _this.twoDate.mindex ; j ++){
    //             end +=  Number(_this.monthLength[j]);
    //         }
    //         start += _this.oneDate.index-1;
    //         end += _this.twoDate.index;
    //         var finData = _this.allDayList.slice(start,end);
    //         _this.keepDays = end - start - 1;
    //     }
    //     else{
    //         _this.keepDays = _this.twoDate.countDate - _this.oneDate.countDate;
    //     }
    // },
    confirm() {
      const _this = this;
      if (_this.setData) {
        _this.setStore("setData", _this.setData);
        // 搜索结果页日历组件
        if (this.isComponent) {
          // 搜索结果页日历组件
          if (!_this.endDateFul) {
            return Toast("请选择入住离开日期");
          }
          const setData = JSON.parse(_this.setData);
          return _this.$emit("changeDate", {
            checkInDay: _this.startDateFul ? setData.checkInDay : "",
            checkOutDay: _this.startDateFul ? setData.checkOutDay : ""
          });
        }
        _this.$router.back(-1);
      } else {
        Toast("请选择入住离开日期");
      }
    },
    renewConfirm: function() {
      const _this = this;
      const localDate = _this.fomatSetData;
      const maxDay = localDate.maxDays ? ocalDate.maxDays : "";
      const minDay = localDate.minDays ? localDate.minDays : "";
      const isAbroad = localDate.isAbroad;
      const cityName = localDate.cityName;
      if (
        JSON.stringify(_this.twoDate) == "{}" &&
        localStorage.getItem("setData") != null
      ) {
        if (localDate.endDateFul == _this.renewDateFul) {
          Toast("请选择离开日期");
          return false;
        }
        window.history.back();
      } else if (JSON.stringify(_this.twoDate) != "{}") {
        const setTwoDay = _this.fix(_this.twoDate.day, 2);
        let setData = {
          startDate: _this.startDate,
          endDate: _this.endDate,
          startDateFul: _this.startDateFul,
          endDateFul: _this.endDateFul,
          checkInDay: localDate.checkInDay.split(".").join("-"),
          checkOutDay:
            _this.twoDate.startYear +
            "-" +
            _this.fix(_this.twoDate.month, 2) +
            "-" +
            _this.fix(setTwoDay, 2),
          price: _this.totalPrice,
          maxDays: maxDay,
          minDays: minDay,
          isAbroad: isAbroad,
          cityName: cityName
        };
        if (setData.endDateFul == _this.renewDateFul) {
          Toast("请选择离开日期");
          return false;
        }
        // 设置续订离开日期；
        let orderInfo = JSON.parse(localStorage.getItem("orderInfo"));
        orderInfo.renewCheckOutDate = setData.checkOutDay.split("-").join(".");
        orderInfo.renewEndWeek = _this.getWeekByDay(
          orderInfo.renewCheckOutDate
        );
        orderInfo = JSON.stringify(orderInfo);
        setData = JSON.stringify(setData);
        localStorage.setItem("setData", setData);
        localStorage.setItem("orderInfo", orderInfo);
        window.history.back();
      } else {
        Toast("请选择离开日期");
      }
    },
    slideCal: function(direct) {
      const _this = this;
      if (direct == "l" && _this.boxIndex > 0) {
        _this.boxIndex -= 1;
      } else if (direct == "r" && _this.boxIndex < 5) {
        _this.boxIndex += 1;
      }
    },
    getWeekByDay: function(dayValue) {
      // dayValue=“2014.01.01”
      const day = new Date(Date.parse(dayValue.replace(/\./g, "/"))); // 将日期值格式化
      const today = new Array(
        "星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六"
      ); // 创建星期数组
      return today[day.getDay()]; // 返一个星期中的某一天，其中0为星期日
    },
    /* 提前离开页 */
    getDateFromCurrentDate: function(fromDate, dayInterval) {
      const curDate = new Date(Date.parse(fromDate.replace(/-/g, "/")));
      curDate.setDate(curDate.getDate() + dayInterval);
      const year = curDate.getFullYear();
      const month =
        curDate.getMonth() + 1 < 10
          ? "0" + (curDate.getMonth() + 1)
          : curDate.getMonth() + 1;
      const day =
        curDate.getDate() < 10 ? "0" + curDate.getDate() : curDate.getDate();
      return year + "-" + month + "-" + day;
    },
    getDaysInOneMonth: function(year, month) {
      var month = parseInt(month, 10);
      const d = new Date(year, month, 0); // 这个是都可以兼容的
      const date = new Date(year + "/" + month + "/0"); // IE浏览器可以获取天数，谷歌浏览器会返回NaN
      return d.getDate();
    },

    slideL: function(year, month) {
      const _this = this;
      let months = month - 1;
      if (months == 0) {
        months = 12;
      }
      const checkInMonth = _this.checkInDate.fullDate.slice(0, 6).slice(4);
      const checkOutMonth = _this.checkOutDate.fullDate.slice(0, 6).slice(4);
      const checkOutYear = _this.fomatSetData.checkOutDate.slice(0, 4);
      const checkInYear = _this.fomatSetData.checkInDate.slice(0, 4);
      if (
        (months >= checkInMonth && months < checkOutMonth) ||
        (checkOutYear >= year && months >= checkInMonth)
      ) {
        if (_this.showIndex != 0) {
          _this.showIndex -= 1;
          _this.showBlackR = true;
        }
      } else {
        _this.showBlackL = false;
      }
    },
    slideR: function(year, month) {
      const months = month + 1;
      const _this = this;
      const checkInMonth = _this.checkInDate.fullDate.slice(0, 6).slice(4);
      const checkOutMonth = _this.checkOutDate.fullDate.slice(0, 6).slice(4);
      const checkOutYear = _this.checkOutDate.fullDate.slice(0, 4);
      const checkInYear = _this.checkInDate.fullDate.slice(0, 4);
      if (
        (months > checkInMonth && months <= checkOutMonth) ||
        checkOutYear > year
      ) {
        if (_this.showIndex != _this.calendar.length - 1) {
          _this.showIndex += 1;
          _this.showBlackL = true;
        }
      } else {
        _this.showBlackR = false;
      }
    },
    fix(num, length) {
      return ("" + num).length < length
        ? (new Array(length + 1).join("0") + num).slice(-length)
        : "" + num;
    },
    clearData() {
      const _this = this;
      _this.startDateFul = "";
      _this.endDateFul = "";
      _this.oneDate = {};
      _this.twoDate = {};
      _this.currentMonth = "";
    },

    coumpent(date1, date2) {
      const date1Str = date1.split("."); // 将日期字符串分隔为数组,数组元素分别为年.月.日
      // 根据年 . 月 . 日的值创建Date对象
      const date1Obj = new Date(date1Str[0], date1Str[1] - 1, date1Str[2]);
      const date2Str = date2.split(".");
      const date2Obj = new Date(date2Str[0], date2Str[1] - 1, date2Str[2]);
      const t1 = date1Obj.getTime();
      const t2 = date2Obj.getTime();
      const dateTime = 1000 * 60 * 60 * 24; // 每一天的毫秒数
      const minusDays = Math.floor((t2 - t1) / dateTime); // 计算出两个日期的天数差
      const days = Math.abs(minusDays); // 取绝对值
      return days;
    },
    close() {
      this.$router.back(-1);
    }
  }
};
</script>
<style scope="" lang="scss">
.calendar_boxwrap {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 9999;
}
.close_icon {
  padding: 10px 0;
  i {
    font-size: 28px;
  }
}
.calendar_wrap {
  background: #fff;
  width: 375px;
  margin: 0 auto;
  color: #212121;
  padding: 0 15px;
  padding-bottom: 45px;
  .earlyLeavecalendar {
    padding-bottom: 0;
  }
  .calendar_head {
    width: 100%;
    height: 50px;
  }
  .calendar_head_box {
    width: 100%;
    height: 50px;
    line-height: 50px;
    display: flex;
    display: -webkit-flex;
    justify-content: space-between;
    -webkit-justify-content: space-between;
    align-items: center;
    -webkit-align-items: center;
    p {
      width: 50%;
      height: 50px;
      line-height: 50px;
    }
    p:last-child {
      text-align: left;
    }
  }
  .calendar_head {
    width: 100%;
    height: 50px;
  }
  .calendar_head p {
    font-size: 12px;
    color: #757575;
  }
  .calendar_head .calendar_head_title {
    font-size: 20px;
    color: #212121;
  }
  .calendar_content {
    width: 340px;
    margin: 0 auto;
  }
  .week_wrap {
    line-height: 37.5px;
    height: 37.5px;
  }
  .week_wrap .week {
    font-size: 12px;
    color: #757575;
    width: 48.5px;
    float: left;
    height: 37.5px;
    line-height: 37.5px;
    text-align: center;
  }
  .tips {
    position: absolute;
    width: 50px;
    height: 20px;
    line-height: 20px;
    background: #212121;
    color: #fff;
    border-radius: 12px;
    top: -24px;
    left: -2px;
    z-index: 99;
    .tip_icon {
      position: absolute;
      top: 19px;
      left: 18px;
      width: 0;
      height: 0;
      border-right: 8px solid transparent;
      border-left: 8px solid transparent;
      border-top: 8px solid #212121;
      z-index: 100;
    }
  }
  .calendar_box {
    padding-bottom: 15px;
    margin-bottom: 15px;
    /*border-bottom: 0.266vw solid #e0e0e0;*/
    .days {
      .grid {
        float: left;
        width: 48.5px;
        height: 33px;
        padding: 1px;
        text-align: center;
        font-size: 12px;
        color: #212121;
        position: relative;
        border-radius: 4px;
        .sale {
          -webkit-transform-origin-x: 0;
          -webkit-transform: scale(0.8);
          position: absolute;
          background: #ff4081;
          color: #fff;
          left: 1px;
          top: 1px;
          border-radius: 2px;
          font-size: 10px;
          display: inline-block;
          width: 15px;
        }
        .maxheight {
          height: 31px;
          line-height: 31px;
        }
        p {
          height: 31px;
        }
        .pwrap {
          p {
            height: 15.5px;
            width: 100%;
            line-height: 15.5px;
            span {
              display: inline-block;
              height: 15.5px;
              width: 100%;
              line-height: 15.5px;
              font-size: 12px;
            }
          }
        }
      }
      .soldout {
        background: url(../static/images/cal_cancle.png);
        background-size: 100% 100%;
        span {
          color: #999;
        }
      }
      .elsep {
        position: relative;
        p {
          line-height: 31px;
          span {
            display: inline-block;
            width: 45px;
            height: 15.5px;
            line-height: 15.5px;
          }
        }
      }
    }
    .grey {
      color: #999;
    }
    .pink-bg {
      background: #ff4081;
      color: #fff;
      border-radius: 4px;
    }
    .grey-bg {
      background: #ff79a7;
      border-radius: 2px;
      color: #fff;
    }
  }
  .cbigfont {
    font-size: 13px;
  }
  .year_wrap {
    position: relative;
    height: 37.5px;
    line-height: 37.5px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    .directBtn {
      width: 100px;
      font-size: 20px;
    }
    .light {
      color: #ccc;
    }
  }
  .year_wrap .year {
    height: 37.5px;
    line-height: 40px;
    font-size: 14px;
    color: #212121;
    font-weight: bold;
  }
  .empty {
    width: 39px;
    height: 37.5px;
    line-height: 37.5px;
  }
  .confirmFbtn {
    position: fixed;
    bottom: 0;
    z-index: 1000;
    padding: 15px 0;
    text-align: center;
    background: #fff;
    box-sizing: border-box;
    width: 345px;
    z-index: 1000;
    border-radius: 20px;
  }
  .confirmBtn {
    height: 40px;
    border-radius: 2px;
    color: #fff;
    line-height: 40px;
    background: #ff4081;
    font-size: 15px;
    font-weight: bold;
    border-radius: 20px;
  }
  .pink-bg2 {
    opacity: 0.7;
  }
  /*提前离开页*/
  .unbook_page {
    position: relative;
    border-bottom: 0.266vw solid #e0e0e0;
    .calendar_content {
      width: 100%;
      height: 45vw;
      border-top: 0.266vw solid #e0e0e0;
      /*border-bottom: 0.266vw solid #e0e0e0;*/
      padding-top: 37.5px;
    }
    .calendar_content .calendar_box {
      float: left;
      width: 91vw;
      padding-bottom: 9vw;
    }
    .calendar_content .calendar_box2 {
      padding-bottom: 0;
      /*border-bottom: 0.266vw solid #e0e0e0;*/
    }
    .calendar_content .tab_wrap {
      position: absolute;
      width: 91vw;
      top: 27.5vw;
    }
    .calendar_content .tab_wrap > span.left {
      display: inline-block;
      border-left: 1.5vw solid transparent;
      border-right: 1.5vw solid #bdbdbd;
      border-top: 1.5vw solid transparent;
      border-bottom: 1.5vw solid transparent;
      float: left;
      margin-left: 17vw;
    }
    .calendar_content .tab_wrap > span.left.blackBg {
      border-right: 1.5vw solid #212121;
    }
    .calendar_content .tab_wrap > span.right {
      display: inline-block;
      border-left: 1.5vw solid #bdbdbd;
      border-right: 1.5vw solid transparent;
      border-bottom: 1.5vw solid transparent;
      border-top: 1.5vw solid transparent;
      float: right;
      margin-right: 17vw;
    }
    .calendar_content .tab_wrap > span.right.blackBg {
      border-left: 1.5vw solid #212121;
    }
    .calendar_box .days .grid {
      overflow: inherit;
    }
    .calendar_content .calendar_box .days .elsep .tips {
      display: inline-block;
      position: absolute;
      top: -7vw;
      background-color: #424242;
      color: #fff;
      font-size: 3.2vw;
      height: 6vw;
      line-height: 6vw;
      width: 18vw;
      left: 50%;
      margin-left: -9vw;
      border-radius: 5vw;
    }
    .calendar_content .calendar_box .days .elsep .tips:after {
      content: "";
      display: inline-block;
      position: absolute;
      border: 1vw solid;
      border-color: #212121 transparent transparent transparent;
      bottom: -2vw;
      left: 50%;
      margin-left: -0.5vw;
    }
    .calendar_content .calendar_box .days .elsep .left_tips {
      display: inline-block;
      position: absolute;
      top: -6vw;
      background-color: #424242;
      color: #fff;
      font-size: 3.2vw;
      height: 6vw;
      line-height: 6vw;
      width: 18vw;
      left: 50%;
      margin-left: -10vw;
      border-radius: 5vw;
      padding: 0 1vw;
    }
    .calendar_content .calendar_box .days .elsep .downTips {
      top: 12vw;
      z-index: 10;
    }
    .calendar_content .calendar_box .days .elsep .left_tips > i {
      float: right;
    }
    .calendar_content .calendar_box .days .elsep .left_tips:after {
      content: "";
      display: inline-block;
      position: absolute;
      border: 1vw solid;
      border-color: #212121 transparent transparent transparent;
      bottom: -2vw;
      left: 50%;
      margin-left: -0.5vw;
    }
    .calendar_content .calendar_box .days .elsep .downTips:after {
      content: "";
      display: inline-block;
      position: absolute;
      border: 1vw solid;
      border-color: transparent transparent #212121 transparent;
      bottom: 6vw;
      left: 50%;
      margin-left: -0.5vw;
    }
    .unbook_left_wrap {
      font-size: 3.7vw;
      height: 14vw;
      line-height: 15vw;
    }
    .unbook_left_wrap > .date {
      float: right;
      color: #ff4081;
    }
    .cancelReasonBox {
      /*margin-top: 120px;*/
    }
    /*续订日历*/
    .calendar_renew .tab_wrap {
      top: 8.5vw;
    }
    .calendar_renew {
      border-top: none;
    }
    .pink-bg2 {
      opacity: 0.7;
    }
    .renewO {
      position: absolute;
      top: -12px;
      right: 8px;
      background: rgba(0, 0, 0, 0.5);
      border-radius: 50%;
      top: -5px;
      z-index: 10;
      width: 30px;
      height: 30px;
      line-height: 30px;
      display: inline-block;
    }
  }
  .transFormR {
    transform: rotate(180deg);
  }
}
.rotate180 {
  transform: rotate(180deg);
  -ms-transform: rotate(180deg); /* IE 9 */
  -moz-transform: rotate(180deg); /* Firefox */
  -webkit-transform: rotate(180deg); /* Safari 和 Chrome */
  -o-transform: rotate(180deg); /* Opera */
  margin-top: -2px;
}
.isOversea {
  position: absolute;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
}
.isOverseaYear {
  margin-top: -10px;
}
</style>



// WEBPACK FOOTER //
// src/components/calendar.vue